




import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { useLocation } from "react-router-dom"
import styled from "styled-components"
import Btn from "../../shared/button/Btn"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { useEffect, useState } from "react"
import { showModal } from "../../../features/modal/modalSlice"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import { deleteLoad } from "../../../features/loadList/loadListSlice"
import InputSelect from "../../shared/input/new/InputSelect"


const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 500px;
        height: 300px;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .content{
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 30px;
            width: 100%;
            gap: 40px;
            overflow: auto;
            
            &::-webkit-scrollbar {
                width: 0;
                width: 8px;
            }
            &::-webkit-scrollbar-thumb {
                background-color: #9e9b9b;
                border-radius: 10px;
            }
            &::-webkit-scrollbar-track {
                background-color: transparent;
            }


            p{
                font-size: var(--font-size-md);
                font-weight: var(--font-weight-lg);
                color: ${({theme}) => theme.mainTextColor};
            }

            .input-container{
                width: 65%;
                .error{
                    font-size: 12px;
                    color: var(--color-main);
                    margin-top: 5px;
                }
            }

            .btn-container{
                display: flex;
                gap: 40px;
            }
        }
    }
`

const silmeSecenekleri = [
    {
        id:1,
        text:"Nakliyeden vazgeçildi."
    },
    {
        id:2,
        text:"Yük verildi."
    },
    {
        id:3,
        text:"Teklif gelmedi."
    },
    {
        id:4,
        text:"Uygun teklif gelmedi."
    },
]

const DeleteLoadPermissionModal = () => {
    const dispatch = useDispatch()
    const location = useLocation()

    const {loadItemData} = useSelector(state => state.loadList)
    const {modalLocation } = useSelector(state => state.modal)
    const { lockScroll, unlockScroll } = useScrollLock();
    const [whyDelete, setWhyDelete] = useState(null)
    const [isSubmitted, setIsSubmitted] = useState(false)

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])


    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    const handleDelete = () => {
        setIsSubmitted(true)
        if(whyDelete){
            const deleteData = {
                description: whyDelete?.text,
                id: loadItemData.id
            }
            dispatch(deleteLoad(deleteData))
            dispatch(showModal(null))
        }
    }

    
  return (
    <Container>
        <div className="modal"  onClick={(e)=> {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
            <div className="content">
                <p>Yükü Neden Silmek İstiyorsunuz?</p>

                <div className="input-container">
                    <InputSelect initialOptions={silmeSecenekleri} data={whyDelete?.text} setData={setWhyDelete} name={"whyDelete"} labelText={"Silme Seçenekleri"} />
                    {
                        isSubmitted && !whyDelete &&
                        <p className="error">Lütfen bir seçim yapınız.</p>
                    }
                </div>
                <div className="btn-container">
                    <Btn bgColor="#E85446" width={"120px"} handleClick={handleDelete}>Yükü Sil</Btn>
                    {/* <Btn bgColor="#BB2649" width={"120px"} handleClick={() => {dispatch(deleteLoad(loadItemData.id)); dispatch(showModal(null))}}>Yükü Sil</Btn> */}
                    <Btn bgColor="#E85446" width={"120px"} handleClick={() => dispatch(showModal(null))}>Vazgeç</Btn>
                </div>
            </div>
        </div>
    </Container>
  )
}

export default DeleteLoadPermissionModal